const LEVELS = { VERBOSE: 1, DEBUG: 2, INFO: 3, WARN: 4, ERROR: 5, NONE: 6 };

const LOG_LEVEL = 'ERROR';

const pad = n => String(n).padStart(2, '0');

const timestamp = () => {
    const d = new Date();
    return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${String(d.getMilliseconds()).padStart(3, '0')}`;
};

class Logger {
    constructor(name) {
        this.name = name;
    }

    _log(level, consoleMethod, args) {
        if (LEVELS[level] < LEVELS[LOG_LEVEL]) {
            return;
        }
        const prefix = `[${level}] ${timestamp()} ${this.name}`;
        const [first, ...rest] = args;
        if (typeof first === 'string') {
            console[consoleMethod](`${prefix} - ${first}`, ...rest);
        } else {
            console[consoleMethod](prefix, ...args);
        }
    }

    debug(...args) {
        this._log('DEBUG', 'log', args);
    }

    info(...args) {
        this._log('INFO', 'info', args);
    }

    warn(...args) {
        this._log('WARN', 'warn', args);
    }

    error(...args) {
        this._log('ERROR', 'error', args);
    }
}

export { Logger };

export default new Logger('BADesk-Frontend');
